import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";
import { buildLegalLd } from "@/lib/page-schemas";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Use — DrHint" },
      { name: "description", content: "Terms and conditions governing your use of the DrHint website." },
      { property: "og:url", content: "https://drhint.com/terms" },
    ],
    links: [{ rel: "canonical", href: "https://drhint.com/terms" }],
    scripts: buildLegalLd({
      url: "https://drhint.com/terms",
      name: "Terms of Use — DrHint",
      description: "Terms and conditions governing your use of the DrHint website, calculators and bill checker.",
      lastModified: "2026-06-01",
      trail: [
        { name: "Home", item: "https://drhint.com/" },
        { name: "Terms", item: "https://drhint.com/terms" },
      ],
    }),
  }),
  component: () => (
    <Layout>
      <article className="mx-auto max-w-3xl px-4 py-10 text-sm leading-relaxed">
        <h1 className="text-3xl font-bold">Terms of Use</h1>
        <p className="mt-2 text-xs text-muted-foreground">Last updated: 1 June 2026</p>

        <p className="mt-6 text-muted-foreground">
          By accessing or using DrHint, you agree to be bound by these terms. If you do
          not agree, please do not use the site.
        </p>

        <h2 className="mt-8 text-xl font-bold">Use of content</h2>
        <p className="mt-2 text-muted-foreground">
          All content on this site — including articles, calculations, design and code — is the
          property of DrHint or its licensors and is protected by applicable copyright
          laws. You may view and print content for personal, non-commercial use. Republishing
          requires written permission.
        </p>

        <h2 className="mt-8 text-xl font-bold">Accuracy of information</h2>
        <p className="mt-2 text-muted-foreground">
          Gold prices on this site are calculated from public market data and are intended for
          informational purposes only. While we update rates every hour and apply standard
          calculation methods, we cannot guarantee perfect accuracy. Always confirm with your local
          jeweller before making a purchase.
        </p>

        <h2 className="mt-8 text-xl font-bold">No financial advice</h2>
        <p className="mt-2 text-muted-foreground">
          Nothing on this site constitutes financial, investment, tax or legal advice. Articles are
          educational in nature. Consult a qualified professional before making investment
          decisions.
        </p>

        <h2 className="mt-8 text-xl font-bold">Third-party links</h2>
        <p className="mt-2 text-muted-foreground">
          The site may contain links to third-party websites. We are not responsible for the
          content, policies or practices of these sites.
        </p>

        <h2 className="mt-8 text-xl font-bold">Limitation of liability</h2>
        <p className="mt-2 text-muted-foreground">
          To the maximum extent permitted by law, DrHint is not liable for any direct,
          indirect, incidental or consequential damages arising from your use of the site or
          reliance on its content.
        </p>

        <h2 className="mt-8 text-xl font-bold">Changes to terms</h2>
        <p className="mt-2 text-muted-foreground">
          We may revise these terms from time to time. Continued use of the site after changes are
          posted constitutes acceptance of the revised terms.
        </p>
      </article>
    </Layout>
  ),
});